// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__249e5","box":"WorkspacesBox_box__1I4aW","node":"WorkspacesBox_node__3zHi3"};